var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex"},[_c('AvatarBasic',{staticClass:"mr-md"}),_vm._v(" "),_c('div',{staticClass:"text-gray-2"},[_c('h5',{staticClass:"text-16 font-semibold",staticStyle:{"line-height":"21px"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_vm._t("text")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }